<template>
  <div class="settlement-bill-detail">
    <el-card shadow="none" v-loading="isLoading">
      <div slot="header" class="flex">
        <div class="flex-item">
          <strong>对账单号：{{ orderId }}</strong>
        </div>
        <el-button
          type="danger"
          @click="reject"
          v-if="!isSupplier && this.orderDetail.orderStatus === 10"
          >驳回</el-button
        >
        <el-button
          type="danger"
          @click="withdraw"
          v-if="isSupplier && this.orderDetail.orderStatus === 10"
          >撤回</el-button
        >
      </div>
      <el-steps :active="currentProcessStatus" align-center>
        <el-step v-for="item in processStatusList" :title="item.statusName" :key="item.statusId" />
      </el-steps>
      <el-divider />
      <el-row>
        <el-col :span="8"><span class="ui-info">城市：</span>{{ orderDetail.cityName }}</el-col>
        <el-col :span="8"><span class="ui-info">供应商：</span>{{ orderDetail.supplier }}</el-col>
        <el-col :span="8"><span class="ui-info">业务线：</span>{{ orderDetail.bizLine }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8"
          ><span class="ui-info">生成时间：</span
          >{{ orderDetail.createTime | formatDate('yyyy-MM-dd HH:mm:ss') }}</el-col
        >
        <el-col :span="8"
          ><span class="ui-info">结算账期：</span>{{ orderDetail.costPeriodStart }}</el-col
        >
      </el-row>
      <el-row>
        <el-col :span="8"
          ><span class="ui-info">金额：</span
          ><span class="ui-danger">{{ orderDetail.totalCost }}元</span></el-col
        >
        <el-col :span="8"
          ><span class="ui-info">状态：</span
          ><span class="ui-danger">{{ orderDetail.orderStatusName }}</span></el-col
        >
      </el-row>
      <el-tabs v-model="activeName">
        <el-tab-pane label="结费详情" name="first">
          <bill-data-list-worker v-if="isWorker" ref="billDataListWorker" />
          <bill-data-list v-else ref="billDataList" />
        </el-tab-pane>
        <el-tab-pane label="发票信息(上传发票)" name="second">
          <invoice-info ref="invoiceInfo" :invoice-enable="true" />
        </el-tab-pane>
        <el-tab-pane label="聚合账单" name="third" v-if="isHavePolyPower">
          <el-table :data="polymerizedOrderList">
            <el-table-column prop="supplier" label="供应商名称" width="130" />
            <el-table-column prop="costPeriod" label="结算账期" />
            <el-table-column prop="bizLine" label="业务线" width="140" />
            <el-table-column prop="regionName" label="区域" />
            <el-table-column prop="cityName" label="城市" width="120" />
            <el-table-column prop="threeOnlyAccName" label="预算项目" />
            <el-table-column prop="attrName" label="扩展科目" width="120" />
            <el-table-column prop="coaAccName" label="COA科目" width="150" />
            <el-table-column prop="category" label="费用类别" v-show="!isWorker" />
            <el-table-column prop="serviceTypeName" label="服务类型" />
            <el-table-column prop="subtypeName" label="子类型" width="130" />
            <el-table-column prop="price" label="含税单价" />
            <el-table-column prop="bikeQuantity" label="Carried bike" width="100" />
            <el-table-column prop="tax" label="税率(%)" />
            <el-table-column prop="cost" label="不含税金额" width="100" />
            <el-table-column prop="money" label="含税金额" width="100" />
            <el-table-column prop="costDeptName" label="成本部门段" width="190" />
            <el-table-column prop="company" label="公司主体" width="200" />
            <el-table-column label="更新日期" width="150">
              <template slot-scope="scope">
                {{ scope.row.updateTime | formatDate('yyyy-MM-dd HH:mm:ss') }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" />
          </el-table>
          <div class="paging-wrapper" v-if="totalPages > 1">
            <el-pagination
              @current-change="handlePageNoChange"
              :current-page.sync="pageNo"
              :page-size="pageSize"
              layout="prev, pager, next, slot, jumper"
              :total="totalAmount"
            >
              <span class="page-indicator"
                ><em>{{ pageNo }}</em
                >/{{ totalPages }}</span
              >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'
import billDataList from '@/components/srm/bill-data-list.vue'
import billDataListWorker from '@/components/srm/bill-data-list-worker.vue'
import invoiceInfo from '@/components/srm/invoice-info.vue'
import filtersFormatDate from '@/mixins/filtersFormatDate'
import qs from 'qs'

export default {
  mixins: [filtersFormatDate, pagination],

  components: { billDataList, billDataListWorker, invoiceInfo },

  data() {
    return {
      isLoading: false,
      isSupplier: false,
      isHavePolyPower: false,
      orderId: '',
      orderDetail: {},
      activeName: 'first',
      processStatusList: [],
      polymerizedOrderList: [],
      isPayAhead: true,
      // 是否是专员
      isWorker: false,
    }
  },

  mounted() {
    this.orderId = this.$route.query.id || ''
    if (this.orderId) {
      this.getUserAuth()
      this.getProcessStatusList()
      this.getOrderDetail()
    } else {
      this.$message.error('缺少必要参数，请检查')
    }
    this.initPagination('getPolymerizedOrderList', false)
  },

  computed: {
    // 当前状态位置
    currentProcessStatus() {
      if (this.processStatusList.length && this.orderDetail.orderProcessStatusId) {
        const statusIndex = this.processStatusList.findIndex(
          item => item.statusId === this.orderDetail.orderProcessStatusId
        )
        return statusIndex + 1
      }
      return 0
    },
  },

  methods: {
    // 获取用户角色
    getUserAuth() {
      this.fetch
        .get('srm_settlementUserAuth')
        .then(res => {
          const { isSupplier, isHavePolyPower } = res.data
          this.isSupplier = isSupplier
          this.isHavePolyPower = isHavePolyPower
        })
        .catch(() => {})
    },
    // 结算单流程状态
    getProcessStatusList() {
      this.fetch
        .get('srm_settlementOrderProcessStatus')
        .then(res => {
          const { statusList } = res.data
          this.processStatusList = statusList || []
        })
        .catch(() => {})
    },
    // 结费单详情
    getOrderDetail() {
      this.isLoading = true
      const params = { orderId: this.orderId }
      this.fetch
        .get('srm_settlementOrderDetail', { params })
        .then(res => {
          this.isLoading = false
          this.orderDetail = res.data || {}
          this.isPayAhead = [1, 8].indexOf(this.orderDetail.orderPayWay) > -1
          // 专员供应商CODE
          this.isWorker = [1, 2, 3, 4, 5].indexOf(this.orderDetail.supplierId) > -1
          this.getSettlementList()
          this.getInvoiceInfo()
          this.getPolymerizedOrderList()
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    // 获取结费账单
    getSettlementList() {
      if (this.isWorker) return this.getWorkerSettlementList()
      const params = this.isPayAhead
        ? {
            orderId: this.orderId,
            period: this.orderDetail.costPeriodStart,
          }
        : {
            supplierId: this.orderDetail.supplierId,
            period: this.orderDetail.costPeriodStart,
            cityCode: this.orderDetail.cityCode,
            bizLine: this.orderDetail.bizLineId,
            orderStatus: 1,
          }
      this.$nextTick(() => {
        this.$refs.billDataList.fetchList(true, params, this.isPayAhead)
      })
    },
    // 获取专员结费账单
    getWorkerSettlementList() {
      const params = {
        supplierFullName: this.orderDetail.supplierId,
        businessLine: this.orderDetail.bizLineId,
        month: this.orderDetail.costPeriodStart,
      }
      this.$nextTick(() => {
        this.$refs.billDataListWorker.getDataList(true, params)
      })
    },
    // 获取发票信息
    getInvoiceInfo() {
      this.$refs.invoiceInfo.initFetch({
        orderId: this.orderId,
      })
    },
    // 聚合账单列表
    getPolymerizedOrderList() {
      if (this.isWorker) return this.getPolymerizedWorkerOrderList()
      let params = {
        prId: this.orderId,
        cityCode: this.orderDetail.cityCode,
        supplierName: this.orderDetail.supplier,
      }
      let url = 'srm_polymerizedOrderList'
      if (this.isPayAhead) {
        params = { orderId: this.orderId }
        url = 'srm_polymerizedPayAheadOrderList'
      }
      params.pageNo = this.pageNo
      params.pageSize = this.pageSize
      this.fetch
        .post(url, this.isPayAhead ? qs.stringify(params) : params)
        .then(res => {
          const { data = [], recordsTotal = 0 } = res
          this.polymerizedOrderList = data
          this.totalAmount = recordsTotal
        })
        .catch(() => {})
    },
    // 聚合账单列表-专员
    getPolymerizedWorkerOrderList() {
      const params = {
        supplier: this.orderDetail.supplierId,
        businessLine: this.orderDetail.bizLineId,
        period: this.orderDetail.costPeriodStart,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      this.fetch
        .get('srm_polymerizedWorkerOrderList', { params })
        .then(res => {
          const { data = [], recordsTotal = 0 } = res
          this.polymerizedOrderList = data
          this.totalAmount = recordsTotal
        })
        .catch(() => {})
    },
    // 驳回
    reject() {
      this.$prompt('请输入驳回原因（最多50个字符）', '', {
        inputType: 'textarea',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[^&<>]{0,50}$/,
        inputErrorMessage: '最多可输入50个字符，不能使用特殊字符 & > <',
      })
        .then(({ value }) => {
          const params = {
            orderId: this.orderId,
            auditOp: 2,
            info: value,
          }
          this.isLoading = true
          this.fetch
            .post('srm_settlementOrderAuditByOrderId', qs.stringify(params))
            .then(res => {
              this.isLoading = false
              this.$message.success('驳回成功')
              this.getOrderDetail()
            })
            .catch(() => {
              this.isLoading = false
            })
        })
        .catch(() => {})
    },
    // 撤回结费单
    withdraw() {
      this.$msgbox
        .confirm('确定撤回吗？', '', {
          type: 'warning',
        })
        .then(() => {
          const params = { orderId: this.orderId }
          this.isLoading = true
          this.fetch
            .post('srm_settlementOrderWithdrawByOrderId', qs.stringify(params))
            .then(res => {
              this.isLoading = false
              this.$message.success('撤回成功')
              this.getOrderDetail()
            })
            .catch(() => {
              this.isLoading = false
            })
        })
        .catch(() => {})
    },
  },
}
</script>
